import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import React from 'react'
import {  Container, Typography, Divider, Button, Grid, Box, AppBar, Toolbar, IconButton, Drawer, List, ListItem } from '@mui/material';

import './DefaultLayout.css'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import CookieConsent from "react-cookie-consent";
import SteLib from 'src/lib/stelib';
import { basename } from '../../configs/EnvironmentConfig';
import moment from 'moment';

import("typeface-hk-grotesk");

// ----------------------------------------------------------------------

const StyledRoot = styled('div')({
  
});

// ----------------------------------------------------------------------

export default function DefaultLayout({setToken}) {
  const drawerWidth = 240;
  const navItems = ['Proiezioni', 'Chi Siamo', 'Contatti', 'Servizi', 'Sponsor', 'Privacy Policy'];
  const [loading, setLoading] = useState(true)
  const [isMobile, setIsMobile] = useState(false)
  const [sponsorsImages, setSponsorsImages] = useState([])
  const sponsorsDirectory = '/images/sponsors';
 
  useEffect(() => {
    if(loading)
    {
      handleResize();

      SteLib.SimpleGet(basename+"/images/sponsors/sponsors.json?timestamp="+moment().valueOf()).then((data) => {
        setSponsorsImages(data)
      })

      setLoading(false)
    }
  }, [loading])

  //choose the screen size 
  const handleResize = () => {
    if (window.innerWidth < 720) {
        setIsMobile(true)
    } else {
        setIsMobile(false)
    }
  }

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize)
  })
    const [mobileOpen, setMobileOpen] = React.useState(false);
  
    const handleDrawerToggle = () => {
      setMobileOpen((prevState) => !prevState);
    };

    let isUnderlined = () => {
      if(window.location.href.indexOf('about_us') >= 0)
      {
        return 1;
      }
      else if(window.location.href.indexOf('contacts') >= 0)
      {
        return 2;
      }
      else if(window.location.href.indexOf('services') >= 0)
      {
        return 3;
      }
      else if(window.location.href.indexOf('sponsors') >= 0)
      {
        return 4;
      }
      else if(window.location.href.indexOf('privacy_policy') >= 0)
      {
        return 5;
      }
      else
      {
        return 0;
      }
    }

    let handleClick = (page) => {
      switch(page)
      {
        default:
        case "Proiezioni":
          window.location.href = `${process.env.PUBLIC_URL}`
          break;
        case "Chi Siamo":
          window.location.href = `${process.env.PUBLIC_URL}/about_us`
          break;
        case "Contatti":
          window.location.href = `${process.env.PUBLIC_URL}/contacts`
          break;
        case "Servizi":
          window.location.href = `${process.env.PUBLIC_URL}/services`
          break;
        case "Sponsor":
          window.location.href = `${process.env.PUBLIC_URL}/sponsors`
          break;
        case "Privacy Policy":
          window.location.href = `${process.env.PUBLIC_URL}/privacy_policy`
          break;
      }
    }
  
    const drawer = (
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
        </Typography>
        <Divider />
        <List>
          {navItems.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton onClick={() => handleClick(item)} sx={{ textAlign: 'center' }}>
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    );
  
    const container = window !== undefined ? window.document.body : undefined;
  
    

    return (
<>
    <Box  sx={{ display: 'flex', minHeight: "calc(100vh - 8rem)"  }}>
    <CookieConsent
        debug={false}
        location="bottom"
        buttonText="Accetta"
        declineButtonText="Rifiuta"
        cookieName="cinemaaurora_cookiechoice"
        flipButtons={!isMobile}
        enableDeclineButton={true}
        buttonWrapperClasses={isMobile ? "" : "ck-buttons"}
        style={{ background: "#2B373B" }}
        contentStyle={{ margin: "2rem !important"}}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        buttonClasses={isMobile ? "" : "ck-accept-desktop"}
        declineButtonClasses={isMobile ? "" : "ck-decline-desktop"}
        expires={150}
      >
        <>
          <p style={{ margin: "1rem", fontSize: "12px" }}>
            Questo sito o gli strumenti terzi da questo utilizzati si avvalgono di cookie necessari al funzionamento ed utili alle finalità illustrate nella cookie policy. Per saperne di più o negare il consenso, consulta la cookie policy. Accettando acconsenti all’uso dei cookie..{" "}
            &nbsp;&nbsp;&nbsp;<a href={`${process.env.PUBLIC_URL}/privacy_policy`}><font style={{color: "#FFD42D"}}><u>Cookie Policy</u></font></a>
          </p>        
        </>
      </CookieConsent>
      <AppBar style={{backgroundColor:"#f9fafb"}} component="nav">
      <div style={{width: "100%", display: "flex", alignItems:"center", height: "3rem", background: "linear-gradient(90deg, #ffda01 0%, #e7ff01 50%, #027473 100%)"}}>
      <div style={{marginRight: "auto", display: "flex", alignItems: "center", order: "2"}}>
          {isMobile ? 
            <small style={{fontSize: "10px", marginLeft: "1rem", color: "#047672"}}><div style={{lineHeight: "12px"}}><b>Biglietti: €8,00 intero <br/> €6,00 ridotto (minori 14 anni)<br/>Spettacoli: €10,00</b></div></small> : 
            <small style={{marginLeft: "2rem", color: "#047672"}}><b>Biglietti: €8,00 intero / €6,00 ridotto (minori 14 anni) / Spettacoli: €10,00</b></small>}
          </div>
        <div style={{marginLeft: "auto", display: "flex", alignItems: "center", order: "2"}}>
          <FacebookIcon onClick={() => window.open('https://www.facebook.com/cinema.aurora', '_blank').focus()} style={{cursor: "pointer", marginRight:'.7rem', fontSize: "2rem", color: "#ffff"}}/>
          <InstagramIcon onClick={() => window.open('https://instagram.com/cinema.aurora?igshid=YmMyMTA2M2Y=', '_blank').focus()} style={{cursor: "pointer", marginRight:'.4rem', fontSize: "2rem", color: "#ffff"}}/>
          <TelegramIcon onClick={() => window.open('https://t.me/cinemaaurora', '_blank').focus()} style={{cursor: "pointer", marginRight:'.7rem', fontSize: "2rem", color: "#ffff"}}/>
          </div>
      </div>
        <Toolbar>
          <IconButton
            color="#333333"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon/>
          </IconButton>
          <div style={{margin:"auto"}}>
            <img onClick={() => {window.location.href = `${process.env.PUBLIC_URL}/`}} width={200} style={{ cursor: "pointer", marginRight: "2rem"}} src={`${process.env.PUBLIC_URL}/images/Logo.png`} alt="logo" />
          </div>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item, i) => (
              <Button onClick={() => handleClick(item)} style={{color:'black'}} key={item} sx={{ color: '#fff' }}>
                {isUnderlined() === i ? <u>{item}</u> : <>{item}</>}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box style={{width:"100%"}}>
        <Toolbar />
        <StyledRoot style={{marginTop: '4rem'}}>
        <Outlet context={[isMobile, loading]} />
      </StyledRoot>
      </Box>
    </Box>
    <Box
        sx={{
          //marginTop: 0,
          height: "5rem",
          marginTop: "3rem"
        }}
      >
        <div style={{padding: "0 2rem 2rem 2rem"}}>
        <Divider ><b>I NOSTRI SPONSOR</b></Divider>
        </div>
        <div>
              <Grid justifyContent="center" alignItems="center" container spacing={4}>
                {sponsorsImages.map((imageName, index) => (
                  <Grid item>
                  <img style={{height: "4rem"}} src={`${process.env.PUBLIC_URL}${sponsorsDirectory}/${imageName}`}></img>
                </Grid>
                ))}
              </Grid>
        </div>
        <div style={{padding: "2rem 2rem 2rem 2rem"}}>
          <Divider></Divider>
        </div>
        <Container maxWidth="lg">
          <Grid container direction="column" alignItems="center">
            <Grid item xs={12}>
              <span style={{color: 'black', fontSize: "1rem"}}>
                Via Caduti 63, 25072 Ponte Caffaro (BS) - <a href="mailto:info@cinema-aurora.it">info@cinema-aurora.it</a>
                </span>
            </Grid>
            <Grid item xs={12}>
              <span style={{color: 'black', fontSize: ".85rem"}}>
                 <b>CinemaAurora | &copy; {`${new Date().getFullYear()}`}</b>
              </span>
            </Grid>
          </Grid>
        </Container>
        <br/>
      </Box>
    </>
  );
}
